import base from './base';
import rooms from './rooms';
import agents from './agents';
import users from './users';
import prescriptions from './prescriptions';
import admin from './admin';

export default [].concat(admin, rooms, agents, users, prescriptions, base);
